module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"tool-title":"Mesures disponibles","measured-parameter":"Paramètre mesuré","data-since":"Première donnée","goto-data":"Voir les chroniques","last-value":"Dernières valeurs","last-update":"Dernière mise à jour le "},"de":{}}')
  delete Component.options._Ctor
}
